export default __webpack_public_path__ + "static/1326-2e7fe822aec9ea99fe8803fe70b5d743.gif";